module.exports = __webpack_public_path__ + "d26e5068d4f15a08968a973e3b32076d.pdf";